/**
 * Mobile mega-menu section. A button shows and hides its panel.
 * Escape is left to the header drawer, which closes the whole menu.
 */
class OuroborosDrawerPanel extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-ouro-drawer-toggle]');
    this.panel = this.querySelector('[data-ouro-drawer-panel]');
    this.button?.addEventListener('click', this.#toggle);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#toggle);
  }

  /** @param {MouseEvent} event */
  #toggle = (event) => {
    event.preventDefault();
    const open = this.button?.getAttribute('aria-expanded') === 'true';
    this.#setOpen(!open);
  };

  /** @param {boolean} open */
  #setOpen(open) {
    if (!this.button || !this.panel) return;
    this.button.setAttribute('aria-expanded', String(open));
    this.panel.toggleAttribute('hidden', !open);
  }
}

if (!customElements.get('ouroboros-drawer-panel')) {
  customElements.define('ouroboros-drawer-panel', OuroborosDrawerPanel);
}
